import socketIOClient from 'socket.io-client';
import { store } from '../store';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Token do Cognito pro handshake do WebSocket. socket.io-client v2 envia
// credenciais via `query` (o `auth` so existe na v3) — entao mandamos o
// access token (o MESMO que o axios usa no Bearer HTTP) em query.token.
// Backend valida no handshake (Fase 1 = warn-only: loga se faltar, nao
// desconecta). Lemos do cache do Amplify (localStorage) de forma SINCRONA
// pra nao precisar tornar as funcoes de socket assincronas. Se nao achar,
// conecta sem token (warn-only tolera) — HTTP segue normal.
const getCognitoAccessTokenSync = () => {
  try {
    const lastAuthKey = Object.keys(window.localStorage).find((k) =>
      k.endsWith('.LastAuthUser'),
    );
    if (!lastAuthKey) return null;
    const prefix = lastAuthKey.replace('.LastAuthUser', '');
    const username = window.localStorage.getItem(lastAuthKey);
    return window.localStorage.getItem(`${prefix}.${username}.accessToken`);
  } catch (e) {
    return null;
  }
};

// Abre o socket no namespace ja com o token no query (quando disponivel).
const connect = (namespace) => {
  const token = getCognitoAccessTokenSync();
  return socketIOClient(
    `${BASE_URL}${namespace}`,
    token ? { query: { token } } : undefined,
  );
};

export function initiateNotifications(userId) {
  const socket = connect('/notifications');

  socket.on(`${userId}-notification`, (data) => {
    store.dispatch({
      type: 'NOTIFICATION/SAGA_SET_NOTIFICATION',
      newNotification: data,
    });

    // if (data.isAlarm) {
    //   store.dispatch({
    //     type: 'EVENTOS/SAGA_BUSCA_QUANTIDADE',
    //   });
    // }
  });

  return socket;
}

export function initiateDashboardData(id, type, zoneId) {
  const socket = zoneId ? connect('/customer/zone/') : connect(`/${type}`);

  socket.on(`customer/${id}/zone/${zoneId}-total`, (data) => {
    store.dispatch({
      type: 'DASHBOARD/SET_THINGS_DATA',
      data,
    });
  });

  return socket;
}

export function initiateDashboardDataPark(id) {
  const socket = connect('/park');

  socket.on(`${id}-total`, (data) => {
    store.dispatch({
      type: 'DASHBOARD/SET_THINGS_DATA',
      data,
    });
    // notifyWarning('Nova notificação');
  });

  return socket;
}

export function initiateSocketConnectionByType(id, type) {
  const socket = connect(`/${type}`);

  socket.on(`${id}-total`, (data) => {
    store.dispatch({
      type: 'SOCKET/SET_DATA',
      data: {
        [`${type}-${id}`]: { data, disconnect: () => socket.disconnect() },
      },
    });
  });

  return socket;
}

export function intiateOperacionalEnergy(id) {
  const socket = connect('/thing');

  socket.on(`${id}-generated`, (data) => {
    store.dispatch({
      type: 'OPERACIONAL/SET_ENERGY',
      data,
    });
  });

  return socket;
}

export function initiateAplicacaoEnergy(id) {
  const socket = connect('/appliance');

  socket.on(`${id}-total`, (data) => {
    store.dispatch({
      type: 'APLICACAO/SET_ENERGY',
      data,
    });
  });

  return socket;
}

export function initiateSocketOperationalHistoric(thingId, variableType) {
  const socket = connect('/thing/operational');
  socket.on(`${thingId}-${variableType}-historic`, (data) => {
    store.dispatch({
      type: 'SOCKET/SET_HISTORIC',
      data: {
        [`${variableType}`]: data,
      },
    });
  });

  return socket;
}
